import React from 'react'
import {Modal, Button} from 'react-bootstrap'
import {Contact} from '../type'
import {useI18n} from '../../../../Utils/_helpers/useI18n'

interface SaleStatusModalProps {
  show: boolean
  contact: Contact | null
  onClose: () => void
  onSave: (newStatus: boolean) => void
}

const SaleStatusModal: React.FC<SaleStatusModalProps> = ({show, contact, onClose, onSave}) => {
  const {t} = useI18n()
  const currentSale = Boolean(contact?.sales)
  const newStatus = !currentSale

  const handleConfirm = () => {
    onSave(newStatus)
  }

  return (
    <Modal show={show} onHide={onClose} centered backdrop='static'>
      <Modal.Header closeButton>
        <Modal.Title className='m-0'>{t('RAW_CONTACT_COLLECTION.UPDATE_SALE_STATUS') || 'Update Sale Status'}</Modal.Title>
      </Modal.Header>
      <Modal.Body className='p-0'>
        <p>
          {currentSale
            ? t('RAW_CONTACT_COLLECTION.CONFIRM_TURN_OFF_SALE') ||
              'Do you want to turn OFF sale status for this contact?'
            : t('RAW_CONTACT_COLLECTION.CONFIRM_TURN_ON_SALE') ||
              'Do you want to turn ON sale status for this contact?'}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          {t('COMMON.CLOSE') || 'Close'}
        </Button>
        <Button variant='primary' onClick={handleConfirm}>
          {t('COMMON.SAVE') || 'Save'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SaleStatusModal
